<header>
    <div class="d-flex align-items-center">
        <a [routerLink]="'/'" class="d-flex align-items-center home-link text-decoration-none">
            <img src="assets/logo.svg" title="Total" alt="Total" class="logo" />
            <div class="app-name"><img src="assets/logo_second_app.svg" title="{{'general_labels.app_name' | translate}}" alt="{{'general_labels.app_name' | translate}}"></div>

        </a>
        <ng-container *ngIf="userService.getUser() | async">
            <span class="pointer ml-auto d-flex align-items-center user" [matMenuTriggerFor]="account">
                <span class="username mr-3">{{userService.getUser().getValue().first_name}} {{userService.getUser().getValue().last_name}}</span>
            <mat-icon svgIcon="account" class="pointer account-icon"></mat-icon>
            <mat-icon color="primary" class="arrow-icon ml-0">arrow_drop_down</mat-icon>
            </span>
            <mat-menu class="mt-2" #account="matMenu" [overlapTrigger]="false">
                <span mat-menu-item class="pr-5" routerLink="/user/my-account">{{ "account.my_account" | translate }}</span>
                <span mat-menu-item routerLink="/auth/logout">{{ "account.logout" | translate }}</span>
            </mat-menu>
        </ng-container>
        <!--div [ngClass]="{'ml-auto' : (userService.getUser() | async) ? false : true}">
            <mat-select [(ngModel)]="currentLang" name="currentLang" (selectionChange)="updateLang(currentLang)" class="lang-select">
                <mat-option value="fr">FR</mat-option>
                <mat-option value="en">EN</mat-option>
            </mat-select>
        </div-->

    </div>
    <ng-container *ngIf="(userService.getUser() | async) && authUser.isAdmin()" class="mt-3">
        <app-navigation></app-navigation>
    </ng-container>
</header>